import script from "./BeneficiarySelector.vue?vue&type=script&setup=true&lang=js"
export * from "./BeneficiarySelector.vue?vue&type=script&setup=true&lang=js"

import "./BeneficiarySelector.vue?vue&type=style&index=0&id=33dd3c1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33dd3c1c"]])

export default __exports__